import React, {memo} from "react"
import {useTemplatedComponent, TemplateSettingsModel} from "@next/templating"
import {MANIFEST} from "@manifest/product-summary"
import connect from "./connect"
import {TextModel} from "../../models/Text"

interface PriceProps {
    template: TemplateSettingsModel
    price: string
    salePrice?: string | null
    wasPrice?: string | null
    text: TextModel
    colourwaysHasSale: boolean
    brandNameEnabled: boolean
    isMade2Measure: boolean
    minPrice?: string | undefined
    productPriceAriaLabelText: string
    isWasPriceARange: boolean
    enableReviewStars: boolean
    isPriceARange: boolean
    overallStarRating: number
    colourwaysHasStarRatingWithRangedPrice: boolean
    brandedMarkdownSalePrice: boolean
    showSpecialOffer: boolean
    saleOrClearance: string
    percentageSavings?: number | null
    shouldShowsSavingsSash?: boolean
}

export const Price = memo(
    ({
        template,
        price,
        salePrice,
        wasPrice,
        text,
        colourwaysHasSale,
        brandNameEnabled,
        isMade2Measure,
        minPrice,
        productPriceAriaLabelText,
        isWasPriceARange,
        enableReviewStars,
        isPriceARange,
        overallStarRating,
        colourwaysHasStarRatingWithRangedPrice,
        brandedMarkdownSalePrice,
        showSpecialOffer,
        saleOrClearance,
        percentageSavings,
        shouldShowsSavingsSash,
    }: PriceProps) => {
        const PriceComponent = useTemplatedComponent(template, MANIFEST as any)
        const PriceComponentProps = {
            price,
            salePrice,
            wasPrice,
            text,
            colourwaysHasSale,
            brandNameEnabled,
            isMade2Measure,
            minPrice,
            productPriceAriaLabelText,
            isWasPriceARange,
            enableReviewStars,
            isPriceARange,
            overallStarRating,
            colourwaysHasStarRatingWithRangedPrice,
            brandedMarkdownSalePrice,
            showSpecialOffer,
            saleOrClearance,
            percentageSavings,
            shouldShowsSavingsSash,
        }
        return <PriceComponent {...PriceComponentProps} />
    },
)

Price.displayName = "Price"

export default connect(Price)
